/**
 * This adds "px" suffix to the received param
 * @param pixels
 * @returns {`${string}px`}
 */
export default pixels => `${pixels}px`
